export default __webpack_public_path__ + "static/media/falda-corta-mujer.299c2bf6.png";